import { api } from "../component/constent";

////////////Consignee///////////////////////////////
// INSERT 

export const insertConsignee = (data) => {
  return api.post("/entry/consignee", data );
};

// UPDATE

export const updateConsignee = (data) => {
  return api.put("/entry/consignee", data );
};

// Consignee List
export const consigneeList = () =>
  api.post("/reports/consigneeList", {});


